import { useCallback, useEffect, useState } from "react";
import {
  fetchAdminCompanyBilling,
  type AdminCompanyBillingStatement,
} from "../api/adminApi";
import { getAuthToken } from "../auth";

export function useAdminCompanyBilling(companyId?: number, status?: string) {
  const [statements, setStatements] = useState<AdminCompanyBillingStatement[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [usingApi, setUsingApi] = useState(false);

  const load = useCallback(async () => {
    if (!getAuthToken()) {
      setUsingApi(false);
      setStatements([]);
      setError(null);
      return;
    }

    setLoading(true);
    setError(null);
    setUsingApi(true);

    try {
      const response = await fetchAdminCompanyBilling({
        company_id: companyId,
        status: status || undefined,
      });
      setStatements(response.statements ?? []);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Impossible de charger les relevés.");
    } finally {
      setLoading(false);
    }
  }, [companyId, status]);

  useEffect(() => {
    void load();
  }, [load]);

  return { statements, loading, error, usingApi, reload: load };
}
